import Config from 'Constants/AppConfig.js'

export default {
    computed: {},
    data() {
        return {
            loader: false
        }
    },
    methods: {
        $isAdmin(){
            return localStorage.getItem('type') == 'admin'
        },
        $isInstructor(){
            return localStorage.getItem('type') == 'instructor'
        },
        $isStudent(){
            return localStorage.getItem('type') == 'student'
        },
        $img_url(path){
            return Config.imgPath + path.replace('public/', '');
        },
        $isDev() {
            return process.env.NODE_ENV === 'development'
        },
        $can(permissionName) {
            return true
            return this.$store.getters.getUser.permissions && this.$store.getters.getUser.permissions.indexOf(permissionName) !== -1
        },
        $status_txt(id, is_boolean = false) {
            if (is_boolean) {
                return id ? theVue.$i18n.t('message.yes') : theVue.$i18n.t('message.no')
            }
            return id ? this.$store.getters.status_ids[id - 1].value : '-'
        },
        $translatable() {
            let output = {}
            Object.keys(this.$config.locales).map((v, i) => {
                return (output[v] = {})
            })
            return output
        },
        $commas(nStr) {
            nStr += ''
            var x = nStr.split('.')
            var x1 = x[0]
            var x2 = x.length > 1 ? '.' + x[1] : ''
            var rgx = /(\d+)(\d{3})/
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2')
            }
            return x1 + x2
        },
        print() {
            // Get HTML to print from element
            const prtHtml = document.getElementById('print').innerHTML

            // Get all stylesheets HTML
            let stylesHtml = ''
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML
            }

            // Open the print window
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

            WinPrint.document.write(`<!DOCTYPE html>
         <html>
         <head>
             ${stylesHtml}
             <style> table, th, td { border-collapse:collapse; border: 1px solid black; width:100%; text-align:right; } .align-items-center { padding-top: 0; padding-bottom: 0; } .v-data-footer{ display:none; } body{ padding:15px } .col-lg-4 { max-width: 33.3333333333%; float:left; } </style>
         </head>
             <body>
                 ${prtHtml}
         </body>
         </html>`)

            WinPrint.document.close()
            WinPrint.focus()
            WinPrint.print()
            WinPrint.close()
        },
        makeURL(path) {},
        fixImg(e) {
            var type = e.target.getAttribute('mime')
            console.log(e)
            console.log(e.target.src)
            switch (type) {
                case 'application/pdf':
                    e.target.src = 'https://www.gravenaegypt.com/images/pdf.png'
                    break
                case 'video/mp4':
                    e.target.src = 'https://www.gravenaegypt.com/images/mp4.png'
                    break
            }
        }
    },
    watch: {}
}
